import './landing-pv-section2.scss'

import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilState, useRecoilValue } from 'recoil'
import { lowerLanguage } from 'src/i18n'
import { usePutDossier } from 'src/networking/terminals'
import { atomDossier, selectorCarousel } from 'src/storage'
import {
  Carousel,
  Dossier,
  DynamicCardCTAStyle,
  DynamicCardProps,
  DynamicCardType,
} from 'src/types'
import { mapDossier } from 'src/utils'

export const usePvSection2 = () => {
  const { t } = useTranslation()
  const nTileItemsPerRow = useRef(0)

  const [dossier, setDossier] = useRecoilState(atomDossier)
  const carousels = useRecoilValue(selectorCarousel)
  const [carouselProductList, setCarouselProductList] = useState<DynamicCardProps[]>([])
  const { crossGate: putDossier } = usePutDossier()

  useEffect(() => {
    const carouselsProduct = carousels?.filter((carousel) =>
      carousel.carouselCode.toUpperCase().includes('CAR_MKT')
    )

    setCarouselProductList(carouselsProduct?.map(createProduct) || [])
  }, [carousels])

  const createProduct = (carousel: Carousel): DynamicCardProps => {
    const link = carousel.link[lowerLanguage]
    const isRedirect = carousel.action.toUpperCase().trim() === 'REDIRECT'

    const thereIsDash = carousel.action.includes('-')
    //A => Acquistabile online, E => Empty
    const isPurchasableOnline = thereIsDash && carousel.action.split('-')[1] === 'A'

    let action = () => {}

    if (isRedirect && link) {
      action = () => {
        window.open(link.replaceAll('"', '').toString(), '_blank')
      }
    }

    if (!isRedirect) {
      action = () => {
        if (thereIsDash) {
          switchDossier(carousel.action.split('-')[0])
          return
        }
        switchDossier(carousel.action)
      }
    }

    return {
      carouselCode: carousel.carouselCode,
      type: parseDynamicCardType(carousel.type),
      title: carousel.title[lowerLanguage],
      description: carousel.description[lowerLanguage],
      image: carousel.imagePath,
      tagLabel: isPurchasableOnline ? 'landing_pv.section2.purchasable_online' : undefined,
      ctaLabel: carousel.actionTitle,
      ctaStyle: DynamicCardCTAStyle.fill,
      enableTMModal: carousel.targetMarketEnabled,
      TMModalContent: carousel.targetMarket[lowerLanguage],
      action,
    }
  }

  function parseDynamicCardType(type?: string): DynamicCardType {
    switch (type) {
      default:
      case DynamicCardType.tile:
        return DynamicCardType.tile
      case DynamicCardType.full:
        return DynamicCardType.full
    }
  }

  function switchDossier(productCode: string): void {
    putDossier(
      {
        headers: {
          xDossierId: dossier.dossierId,
        },
        body: {
          productCode: productCode,
        },
      },
      {
        onSuccess: (newDossier) => {
          const dossier: Dossier = mapDossier(newDossier)
          setDossier(dossier)
        },
      }
    )
  }

  return { carouselProductList, nTileItemsPerRow, t }
}
